<div class="example-container mat-elevation-z2">
  <mat-table #table
    [dataSource]="dataSource">
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef>Name</mat-header-cell>
      <mat-cell *cdkCellDef="let row"><a [routerLink]="['/admin/organisations', row.id]">{{ row.name }}</a></mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="number">
      <mat-header-cell *cdkHeaderCellDef>Phone Number</mat-header-cell>
      <mat-cell *cdkCellDef="let row"> {{ row.contactNumber }} </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="address">
      <mat-header-cell *cdkHeaderCellDef>Address</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <span *ngIf="row.address"> {{ row.address?.address1}},&nbsp;</span>
        <span *ngIf="row.address?.address2">{{ row.address.address2 }}</span>
        <span *ngIf="row.address?.town">{{ row.address.town }} {{ row.address.state }} {{ row.address.postcode }}</span>
      </mat-cell>
    </ng-container>
    <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>